import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../services/customer_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// eslint-disable-next-line
import { ComboboxFieldSubArray } from "../../../../Components/formElements/ComboboxFieldSubArray";
import DataTable from "react-data-table-component";
import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import {
  formatDate,
  validateBankAccount,
  validateContactNumber,
  // validateEmail,
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import toast from "react-hot-toast";
// eslint-disable-next-line
import GoogleMapComponent from "../Common/GoogleMapComponent";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import Loader from "../../../../Components/Loader";
import Layout from "../../../../Layout/Layout";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { getLoginUserData } from "../../../../redux/feature/userSlice";
import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import { useReactToPrint } from "react-to-print";
// import PrintKYCRegistration from "../KYCForm/PrintKYCRegistration";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  bankStatements,
  cashExpensesNr,
  purchaseNr,
} from "../../../../redux/feature/customer_app/customerSlice";
import { addInvoiceID } from "../../../../redux/feature/customer_app/preSalesSlice";
import { hasAccess } from "../../../../utils/roleUtils";
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import accountsApi from "../../../../services/accountsCommonService";
// import { kycExistingCustomer } from "../../../../redux/feature/customer_app/customerV1Slice";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const CustomerRegistrationDetailsV2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Customer List");

  // let customerData = useSelector((state) => state?.customer?.data); // User Details from Store
  let customerID = useSelector((state) => state?.customer?.customerID); // User Details from Store
  let workflow = useSelector((state) => state?.customer?.customerWorkflow); // workflow from Store
  let userData = useSelector((state) => state?.user?.data);
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig);

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  // eslint-disable-next-line
  let productDocumentAttachment = [
    {
      id: "1",
      name: "Google Pin location",
    },
    {
      id: "2",
      name: "Project Photos",
    },
    {
      id: "3",
      name: "Blueprints or Layout Plans",
    },
    {
      id: "5",
      name: "Project Document",
    },
  ];
  const [updateTallyMode, setUpdateTallyMode] = useState(false);

  const handleUpdateTally = () => {
    setUpdateTallyMode(true);
  };

  const handleCancelTally = () => {
    setUpdateTallyMode(false);
  };
  const status = [
    { id: 1, name: "Done" },
    { id: 2, name: "Pending" },
  ];
  const SalesOfficerData = [
    { id: 1, code: "A000", name: "Amarendra" },
    { id: 2, code: "S0001", name: "Manjunatha" },
    { id: 3, code: "S0002", name: "Umesh" },
    { id: 4, code: "S0003", name: "Amith" },
    { id: 5, code: "S0004", name: "Rajesh" },
    { id: 6, code: "S0005", name: "Satish" },
  ];
  const dropDownLackCrore = [
    { id: 1, name: "Lakhs" },
    { id: 1, name: "Crore" },
  ];
  let dropDownYear = [
    {
      id: "1",
      name: "2024-2025",
    },
    {
      id: "2",
      name: "2023-2024",
    },
    {
      id: "3",
      name: "2021-2022",
    },
    {
      id: "4",
      name: "2019-2020",
    },
    {
      id: "5",
      name: "2017-2018",
    },
  ];
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line no-unused-vars
  const [getPaymentTypeStatus, setPaymentTypeStatus] = useState("");

  const [editMode, setEditMode] = useState(true);

  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  // const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [nextId, setNextId] = useState(1); // Start IDs from 1
  const [loading, setLoading] = useState(false);
  const [modalShowApprove, setModalShowApprove] = useState(false);
  const [getAction, setAction] = useState("");

  const [editorContent, setEditorContent] = useState(""); //remarks

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const handleDealerChange = (index, fieldName, value) => {
    setFormInputs((prev) => ({
      ...prev,
      delarDetails: (prev?.delarDetails || []).map((dealer, dealerIndex) =>
        dealerIndex === index
          ? {
              ...dealer,
              [fieldName]: value,
            }
          : dealer,
      ),
    }));
  };

  const addDealer = () => {
    setFormInputs((prev) => ({
      ...prev,
      delarDetails: [
        ...(prev?.delarDetails || []),
        {
          id: Date.now(),
          delarName: "",
          delarAddress: "",
          delarPinCode: "",
          delarContactName: "",
          delarContactNumber: "",
          activeInactive: true,
        },
      ],
    }));
  };

  const removeDealer = (index) => {
    setFormInputs((prev) => ({
      ...prev,
      delarDetails: (prev?.delarDetails || []).filter(
        (_, dealerIndex) => dealerIndex !== index,
      ),
    }));
  };
  //////Sales Officer /////
  const [getSalesOfficer, setSalesOfficer] = useState([
    {
      id: Date.now(),
      salesOfficerName: "",
      salesOfficerCode: "",
      fromDate: "",
      toDate: "",
      remarks: "",
    },
  ]);
  const deleteSalesOfficer = (id) => {
    const updatedData1 = getSalesOfficer.filter((doc) => doc.id !== id);
    setSalesOfficer(updatedData1);
  };
  const addSalesOfficer = () => {
    const newDocument = {
      id: Date.now(),
      salesOfficerName: "",
      salesOfficerCode: "",
      fromDate: "",
      toDate: "",
      remarks: "",
    };
    setSalesOfficer((prevData) => [...prevData, newDocument]);
  };

  const handleSalesOfficer = (id, fieldName, value) => {
    const errors = {};

    if (fieldName === "salesOfficerName") {
      const selectedOfficer = SalesOfficerData.find(
        (item) => item.name === value,
      );

      setSalesOfficer((prevData) =>
        prevData.map((doc) =>
          doc.id === id
            ? {
                ...doc,
                salesOfficerName: selectedOfficer?.name || "",
                salesOfficerCode: selectedOfficer?.code || "",
              }
            : doc,
        ),
      );

      setValidation((prev) => ({
        ...prev,
        [`${id}_salesOfficerName`]: "",
      }));

      return;
    }

    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    setSalesOfficer((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  const [getdocumentType, setdocumentType] = useState([]);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);

  const [validation, setValidation] = useState({});
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  // ADD new projects
  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "",
        documentType: "",
        certificateCode: "",
      },
    ],
    getLocations: [],
  };

  const [getProjectDetails, setProjectDetails] = useState([newProject]);

  //Company Profile
  const [getCompanyProfile, setCompanyProfile] = useState({
    typeOfCompany: "",
    typeOfFirm: "",
    creditLimit: "",
    creditLimitINR: "",
    typeOfCustomerSegment: "",
    creditPeriodDays: "",
    numberOfYearsInBusiness: "",
    security: "",
    detailsOfSecurity: "",
    paymentType: "",
  });
  const [getprojectCompletedData, setprojectCompletedData] = useState();

  const [getCompanyCode, setCompanyCode] = useState([]);

  //bank details
  const [getBankDetails, setBankDetails] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getBankDetailsData, setBankDetailsData] = useState([
    {
      id: Date.now(),
      bankKey: "",
      bankCountryDescription: "",
      bankAccountName: "",
      bankAddress: "",
      bankBranchName: "",
      bankCurrency: "",
      bankAccountNumber: "", // ✅ Add this field
      bankNotListed: "No",
    },
  ]);

  /* project completed data and col */
  let projectCompletedCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Project Name",
      selector: (row) => row.projectNameCopleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectNameCopleted"
          placeholder=""
          value={row.projectNameCopleted || ""}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
          disabled={editMode}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Project Tenure",
      selector: (row) => row.projectTenureCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectTenureCompleted"
          placeholder=""
          value={row.projectTenureCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Start Date",
      selector: (row) => row.startDateCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="startDateCompleted"
          placeholder=""
          type="date"
          value={row.startDateCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "End Date",
      selector: (row) => row.endDateCompleted || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="endDateCompleted"
          type="date"
          placeholder=""
          value={row.endDateCompleted || ""}
          disabled={editMode}
          onChange={(event) =>
            handleInputFieldChangeCompleted(row.local_id, event)
          }
        />
      ),
      width: "220px",
    },

    {
      name: "Delete",
      omit: editMode ? true : false,
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button onClick={() => removeProjecetDocumentItemRow(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let projectCompletedData = [
    {
      local_id: 1,
      projectNameCopleted: "",
      projectTenureCompleted: "",
      startDateCopleted: "",
      endDateCopleted: "",
      statusCopleted: "",
    },
  ];

  // Project on Hand col and Data
  let projectOnHandCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Project Name",
      selector: (row) => row.projectNameOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectNameOnHand"
          placeholder=""
          value={row.projectNameOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Project Tenure",
      selector: (row) => row.projectTenureOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectTenureOnHand"
          placeholder=""
          value={row.projectTenureOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Start Date",
      selector: (row) => row.startDateOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="startDateOnHand"
          type="date"
          placeholder=""
          value={row.startDateOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Tentative Date",
      selector: (row) => row.endDateOnHand || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="endDateOnHand"
          type="date"
          placeholder=""
          value={row.endDateOnHand || ""}
          disabled={editMode}
          onChange={(event) => handleInputChangeOnHand(row.local_id, event)}
        />
      ),
      width: "220px",
    },
    {
      name: "Delete",
      omit: editMode ? true : false,
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          onClick={() => removeprojectDetailContactPersonItemRow(row.local_id)}
        >
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let projectOnHandData = [
    {
      local_id: 1,
      projectNameOnHand: "",
      projectTenureOnHand: "",
      startDateOnHand: "",
      endDateOnHand: "",
      statusOnHand: "",
    },
  ];
  const [getProjectOnHandData, setProjectOnHandData] = useState();

  const [getCustomerProfile, setCustomerProfile] = useState();

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  // eslint-disable-next-line
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  // const toggleCardVisibility7 = () => {
  //   setCardVisible7(!isCardVisible7);
  // };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    userId: customerID,
    organisationName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",

    version: "v0",
    status: "Non Invited",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerName: "",

    plantAddress:
      "Bharathi Rock Products India PVT Ltd Sy No.9, Kanivenarayanapura(V), Muddenahalli Post,Chikkabalapura-562101",
    projectLocation: "",

    customerTypeCode: "C03",
    customerTypeDesc: "Domestic",
    activeInactive: true,
    approveStatus: "Pending admin approval",
  });

  // eslint-disable-next-line no-unused-vars
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  // useEffect(() => {
  //   // console.log(">>Check getDropdownData Data", getDropdownData);
  //   if (getDropdownData?.codeType === "country") {
  //     setFormInputs((formInputs) => ({
  //       ...formInputs,
  //       [getDropdownData?.textField]: getDropdownData?.name,
  //       [getDropdownData?.textCode]: getDropdownData?.code,
  //       [getDropdownData?.textDesc]: getDropdownData?.description,
  //     }));
  //     getStateData(getDropdownData?.code);
  //   } else if (getDropdownData?.textCode === "paymentTypeCode") {
  //     setFormInputs((formInputs) => ({
  //       ...formInputs,
  //       [getDropdownData?.textField]: getDropdownData?.name,
  //       [getDropdownData?.textCode]: getDropdownData?.code,
  //       [getDropdownData?.textDesc]: getDropdownData?.description,
  //     }));
  //     setCompanyProfile((prev) => ({
  //       ...prev,
  //       paymentType: getDropdownData?.name,
  //     }));
  //     setPaymentTypeStatus(getDropdownData?.name);
  //   } else {
  //     setFormInputs((formInputs) => ({
  //       ...formInputs,
  //       [getDropdownData?.textField]: getDropdownData?.name,
  //       [getDropdownData?.textCode]: getDropdownData?.code,
  //       [getDropdownData?.textDesc]: getDropdownData?.description,
  //     }));
  //     setCompanyProfile((formInputs) => ({
  //       ...formInputs,
  //       [getDropdownData?.textField]: getDropdownData?.name,
  //       [getDropdownData?.textCode]: getDropdownData?.code,
  //       [getDropdownData?.textDesc]: getDropdownData?.description,
  //     }));
  //   }
  //   setValidation((prev) => ({
  //     ...prev,
  //     [getDropdownData?.textField]: "",
  //   }));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getDropdownData]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "salesOfficerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textCode === "typeOfFirmCode") {
      setCompanyProfile((companyProfile) => ({
        ...companyProfile,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textCode === "paymentTypeCode") {
      setCompanyProfile((companyProfile) => ({
        ...companyProfile,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "salesOfficerCode") {
      setSalesOfficer((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // console.log(">> formInputs", formInputs);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj5 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id,
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  // const handleChangeCustomerContacts = (id, fieldName, value) => {
  //   setcustomerContactPerson((prevData) =>
  //     prevData.map((doc) =>
  //       doc.id === id ? { ...doc, [fieldName]: value } : doc
  //     )
  //   );
  // };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    // Required field validation
    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    // Contact number format validation
    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }
    // Email format validation
    // if (fieldName === "contactEmail" && validateRequired(value)) {
    //   if (!validateEmail(value)) {
    //     errors[fieldName] = "Invalid email address.";
    //   }
    // }

    // Update state
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
    // Update validation state
    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
  };

  /* ---------------------project details block-------- */
  // eslint-disable-next-line
  const addProjectDetails = () => {
    newProject.projectCode = nextId + 1;
    newProject.projectCodeDesc = "PROJECT_" + (nextId + 1);
    setProjectDetails((prevData) => [...prevData, newProject]);
    setNextId((prevId) => prevId + 1);
  };
  // eslint-disable-next-line
  const removeProjectDetails = (indexToRemove) => {
    setProjectDetails(
      getProjectDetails.filter((_, idx) => idx !== indexToRemove),
    );
  };
  // eslint-disable-next-line
  const handleProjectInputChange = (value, index, fieldName) => {
    // console.log(">>handleProjectInputChange", { index, fieldName, value });

    if (index === undefined || value === undefined) return;

    // Update the specific project detail
    setProjectDetails((prevDetails) =>
      prevDetails.map((item, idx) =>
        idx === index ? { ...item, [fieldName]: value } : item,
      ),
    );
  };

  /* --------------------- Contact Person Inside Project Details -------- */

  //Add Projects
  // eslint-disable-next-line
  const addProjectCantactPersonNew = (projectIndex) => {
    const newContactPerson = {
      id: Date.now(), // Unique ID for each contact person
      projectContactPosition: "",
      projectContactTitle: "",
      projectContactName: "",
      projectContactNumber: "",
      projectContactEmail: "",
    };

    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: [
          ...updatedProjectDetails[projectIndex].getProjectContactPerson,
          newContactPerson,
        ],
      };
      return updatedProjectDetails;
    });
  };
  //Delete Project
  // eslint-disable-next-line
  const deleteProjectContactPerosnNew = (projectIndex, id) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.filter((contact) => contact.id !== id),
      };
      return updatedProjectDetails;
    });
  };
  //Project Contact Inputs
  // eslint-disable-next-line
  const handleChangeProjectContactsNew = (
    projectIndex,
    contactId,
    fieldName,
    value,
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value } // Update the specific field
              : contact, // Keep other contacts unchanged
        ),
      };
      return updatedProjectDetails;
    });
  };
  //Dropdown
  // eslint-disable-next-line
  const handleChangeProjectContactsNewDropdown = (
    projectIndex,
    contactId,
    fieldName,
    value,
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Update the specific contact person's field
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value.name } // Update the field with the full object
              : contact, // Keep other contacts unchanged
        ),
      };

      return updatedProjectDetails;
    });
  };

  /* ---------------------project Certifications  -------- */
  // eslint-disable-next-line
  const deleteProjectCertifications = (projectIndex, certificationId) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Filter out the certification with the specified id
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: updatedProjectDetails[
          projectIndex
        ].getProjectCertifications.filter(
          (certification) => certification.id !== certificationId,
        ),
      };

      return updatedProjectDetails;
    });
  };
  // eslint-disable-next-line
  const addProjectCertifications = (projectIndex) => {
    const newCertification = {
      id: Date.now(), // Unique ID for the new certification
      name: "Document 1",
      documentType: "",
      certificateCode: "29AADCN1012B1Z6",
    };

    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Add the new certification to the getProjectCertifications array
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: [
          ...updatedProjectDetails[projectIndex].getProjectCertifications,
          newCertification,
        ],
      };

      return updatedProjectDetails;
    });
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  //document upload for projects
  // eslint-disable-next-line
  const onSuccessUploadProjectDocumentType = (
    projectIndex,
    docId,
    fieldName,
    attachmentId,
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: updatedProjectDetails[
          projectIndex
        ].getProjectCertifications.map((cert) =>
          cert.id === docId ? { ...cert, [fieldName]: attachmentId } : cert,
        ),
      };

      return updatedProjectDetails;
    });
  };
  // eslint-disable-next-line
  const onHandleMapData = (data) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      // Update the getLocations array with the new data
      updatedProjectDetails[data?.projectIndex] = {
        ...updatedProjectDetails[data?.projectIndex],
        getLocations: [
          ...(updatedProjectDetails[data?.projectIndex].getLocations || []), // Ensure getLocations is an array
          {
            distance: data.distance,
            duration: data.duration,
            fromToCoords: data.fromToCoords,
            plantAddress: data.plantAddress,
            projectLocation: data.projectLocation,
          },
        ],
      };

      return updatedProjectDetails;
    });
  };

  const loadFirstLevelData = async (page) => {
    setLoading(true);
    // console.log(">> customerID", customerID);
    if (customerID !== "") {
      let obj = {
        documentNumber: customerID,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getCustomerDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          setcustomerContactPerson(item?.data[0]?.contactDetails || []);
          setDocumentTypeData(item?.data[0]?.certifications || []);
          setProjectDetails(item?.data[0]?.projectDetails || newProject);
          const salesOfficerDetails = (
            item?.data[0]?.salesOfficerDetails || []
          ).map((doc) => {
            const selectedOfficer = SalesOfficerData.find(
              (officer) => officer.code === doc.salesOfficerCode,
            );

            return {
              ...doc,
              salesOfficerCode: doc.salesOfficerCode || "",
              salesOfficerName:
                selectedOfficer?.name || doc.salesOfficerName || "",
            };
          });

          setSalesOfficer(salesOfficerDetails);
          setCompanyProfile(item?.data[0]?.companyProfile || []);
          setprojectCompletedData(item?.data[0]?.projectCompleted || []);
          setProjectOnHandData(item?.data[0]?.porjectOnHand || []);
          setCustomerProfile(item?.data[0]?.customerProfile || []);
          setFinancialTurnover(item?.data[0]?.financialTurnover || []);
          setBankDetails(item.data[0]?.bandkDetails);
          setFuelHistory(item.data[0]?.Customer_InvoiceRegisterDocs);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      if (JSON.stringify(workflow) === "{}") {
        if (workflow?.page === "Inbox") {
          navigate(Constants.INBOX);
        } else {
          navigate(Constants.OUTBOX);
        }
      } else {
        navigate(CustomerConstants.CUSTOMER_V1_CUSTOMER_MASTER_LIST);
      }
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editCustomer = () => {
    setEditMode(false);
  };
  const canelUpdate = () => {
    setEditMode(true);
  };

  // SAVE
  const handleUpdate = async () => {
    const requiredFields = [];
    let hasError = false;

    const validationErrors = {};

    if (!validateRequired(formInputs.organisationName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        organisationName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.organisationName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        organisationName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.address)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        address: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.address2)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        address2: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.city)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        city: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.cityPostalCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        cityPostalCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.salesOfficerName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        salesOfficerName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    // if (!validateRequired(formInputs.companyCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     companyCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    getcustomerContactPerson?.forEach((doc) => {
      const id = doc.id;
      if (!doc.contactName) {
        validationErrors[`${id}_contactName`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      } else if (!validateName(doc.contactName)) {
        validationErrors[`${id}_contactName`] = message.VALID_CUSTOMER_NAME;
        requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
        hasError = true;
      }
      // if (!doc.contactEmail) {
      //   validationErrors[`${id}_contactEmail`] = message.FILL_REQUIRED_FIELD;
      //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      //   hasError = true;
      // } else if (!validateEmail(doc.contactEmail)) {
      //   validationErrors[`${id}_contactEmail`] = message.VALID_MAIL_ID;
      //   requiredFields.push(`${message.VALID_MAIL_ID
      //   }`);
      //   hasError = true;
      // }

      if (!doc.contactNumber) {
        validationErrors[`${id}_contactNumber`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      } else if (!validateContactNumber(doc.contactNumber)) {
        validationErrors[`${id}_contactNumber`] = message.VALID_CONTACT_NUMBER;
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        hasError = true;
      }
    });

    getDocumentTypeData?.forEach((doc) => {
      const id = doc.id;

      if (!doc.documentNumber) {
        validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      }
    });

    getBankDetails?.forEach((doc) => {
      const id = doc.id;
      if (doc.bankNotListed === "Yes") {
        if (!doc.bankAccountNumber) {
          validationErrors[`${id}_bankAccountNumber`] =
            message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        } else if (!validateBankAccount(doc.bankAccountNumber)) {
          validationErrors[`${id}_bankAccountNumber`] = message.VALID_BANK_ACC;
          requiredFields.push(message.VALID_BANK_ACC);
          hasError = true;
        }

        if (!doc.bankKey) {
          validationErrors[`${id}_bankKey`] = message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        }
        if (!doc.AccountHolderName) {
          validationErrors[`${id}_AccountHolderName`] =
            message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        }
      }
    });

    // Set validation state only once
    setValidation((prev) => ({
      ...prev,
      ...validationErrors,
    }));

    const anyFieldHasError = Object.values(validationErrors).some(
      (val) => val !== null && val !== "",
    );

    if (hasError || anyFieldHasError) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    formInputs.contactDetails = getcustomerContactPerson.map((doc) => ({
      ...doc,
      contactPosition: `${doc.contactPositionCode || ""} - ${
        doc.contactPositionDesc || ""
      }`,
      contactTitle: `${doc.contactTitleCode || ""} `,
    }));

    formInputs.certifications = getDocumentTypeData.map((doc) => ({
      ...doc,
      documentType: `${doc.documentTypeCode || ""} - ${
        doc.documentTypeDesc || ""
      }`,
    }));

    // formInputs.userId = customerID;
    // formInputs.contactDetails = getcustomerContactPerson;
    // formInputs.certifications = getDocumentTypeData;
    formInputs.projectDetails = getProjectDetails;

    formInputs.companyProfile = getCompanyProfile;
    formInputs.projectCompleted = getprojectCompletedData;
    formInputs.financialTurnover = getFinancialTurnover;
    formInputs.porjectOnHand = getProjectOnHandData;
    formInputs.customerProfile = editorContent;
    formInputs.bandkDetails = getBankDetails;
    formInputs.delarDetails = formInputs?.delarDetails || [];
    formInputs.supplierDetails = formInputs?.supplierDetails || [];
    formInputs.activeInactive = await ItemService.updateCustomerV1(
      formInputs,
    ).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        // navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);
        const empTypes = ["C05", "C06", "C07", "C08", "C09"];
        if (empTypes.includes(formInputs?.customerTypeCode)) {
          navigate(CustomerConstants.CUSTOMER_V2_EMP_LIST);
        } else {
          navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);
        }
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };
  const [customerCredit, setCustomerCredit] = useState(null);
  const [creditLoading, setCreditLoading] = useState(false);
  const [creditError, setCreditError] = useState("");

  const getCustomerCreditByCode = async (customerCode) => {
    if (!customerCode) {
      setCustomerCredit(null);
      setCreditError("");
      return;
    }

    try {
      setCreditLoading(true);
      setCreditError("");

      const result = await accountsApi.customerCreditByCode(customerCode);

      if (result?.status === 200 && result?.data) {
        setCustomerCredit(result.data);
      } else {
        setCustomerCredit(null);
        setCreditError(result?.message || "Customer credit details not found");
      }
    } catch (error) {
      setCustomerCredit(null);
      setCreditError(error?.message || "Unable to fetch customer credit");
    } finally {
      setCreditLoading(false);
    }
  };

  useEffect(() => {
    if (customerID) {
      getCustomerCreditByCode(customerID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerID]);
  useEffect(() => {
    setValidation((prev) => {
      const updated = {};
      Object.keys(prev)?.forEach((key) => {
        if (!/^\d+_contact/.test(key)) updated[key] = prev[key]; // keep only non-contact validations
      });
      return updated;
    });
  }, [getcustomerContactPerson]);
  const creditLimit = Number(customerCredit?.creditLimit ?? 0);
  const outstanding = Number(customerCredit?.outstanding ?? 0);
  const openOrders = Number(customerCredit?.openOrders ?? 0);
  const creditAvailable = Number(customerCredit?.availableCredit ?? 0);
  const creditExceeded = creditAvailable < 0;
  // Approve
  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    // obj.data = {
    //   items: data,
    // };
    let newObj = { ...bodyObj, ...obj };

    // console.log(">> obj", obj);

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        navigate(Constants.INBOX);
        dispatch(getLoginUserData());
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const showApproveModal = async (name) => {
    setModalShowApprove(true);
    setAction(name);
  };
  const hideModalApprove = () => {
    setModalShowApprove(false);
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  const navigateToWorkflow = () => {
    if (workflow?.page === "Inbox") {
      navigate(Constants.INBOX);
    } else {
      navigate(Constants.OUTBOX);
    }
  };

  // console.log(">> workflow", workflow);

  //print
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `KYC_${Math.floor(Math.random() * 1000000)}`,
  });
  //Financial Turnover
  const [getFinancialTurnover, setFinancialTurnover] = useState([
    {
      id: 1,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
    {
      id: 2,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
    {
      id: 3,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
  ]);

  const handleChangeFinancialTurnover = (id, fieldName, value) => {
    setFinancialTurnover((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
  };
  const deleteFinancialTurnover = (id) => {
    const updatedData1 = getFinancialTurnover.filter((doc) => doc.id !== id);
    setFinancialTurnover(updatedData1);
  };
  // project completed
  const removeProjecetDocumentItemRow = (local_id) => {
    setprojectCompletedData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };
  const addProjecetDocumentItemRow = () => {
    setprojectCompletedData((prevRows) => {
      projectCompletedData[0].local_id = prevRows.length + 1;
      projectCompletedData[0].purchasingReqDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...projectCompletedData];
    });
  };

  const handleInputFieldChangeCompleted = (local_id, event) => {
    const { name, value } = event.target;

    setprojectCompletedData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row,
      ),
    );
  };
  /* Project on Hand  */
  const removeprojectDetailContactPersonItemRow = (local_id) => {
    setProjectOnHandData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };
  const addprojectDetailContactPersonItemRow = () => {
    setProjectOnHandData((prevRows) => {
      projectOnHandData[0].local_id = prevRows.length + 1;
      projectOnHandData[0].purchasingReqDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...projectOnHandData];
    });
  };

  const handleInputChangeOnHand = (local_id, event) => {
    const { name, value } = event.target;
    setProjectOnHandData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row,
      ),
    );
  };
  //remarks
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateReferenceCustomerDetails = () => {
    navigate(CustomerConstants.CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS);
  };

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //bank
  const handleChangeBankInfo = (id, key, value) => {
    const updatedBankDetails = getBankDetails.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [key]: value,
          ...(key === "bankKey" &&
            (() => {
              const selectedBank = getBankDetailsData.find(
                (bank) => bank.name === value,
              );
              return selectedBank
                ? {
                    bankCountryDescription: selectedBank.bankCountryDescription,
                    bankAccountName: selectedBank.bankAccountName,
                    bankAddress: selectedBank.bankAddress,
                    bankBranchName: selectedBank.bankBranchName,
                    bankCurrency: selectedBank.bankCurrency,
                  }
                : {};
            })()),
        };
      }
      return item;
    });

    setBankDetails(updatedBankDetails);

    // Validate
    // const errorMsg = !value ? `${key} is required.` : "";

    setValidation((prev) => ({
      ...prev,
      // [`${id}_${key}`]: errorMsg,
    }));
  };

  const onSuccessUploadBankDocumentType = (data, index) => {
    const updatedBankDetails = [...getBankDetails];
    updatedBankDetails[index][data.fieldName] = data.attachmentId;
    setBankDetails(updatedBankDetails);
  };
  // eslint-disable-next-line
  const handleCompanyProfileChange = ({ target: { name, value } }) => {
    setCompanyProfile((prevCompanyProfile) => ({
      ...prevCompanyProfile,
      [name]: value,
    }));
  };

  // eslint-disable-next-line
  const [getFuelHistory, setFuelHistory] = useState();

  const fuelHistoryColum = [
    {
      name: "Transaction No",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transactionType)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Transaction Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.bankTransactionDate)}{" "}
          </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Company",
      selector: (row) => row.companyCodeDesc || "--",
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold">
            {row.companyCodeDesc}{" "}
          </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.customerCodeDesc,
      // sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.customerCodeDesc} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    // {
    //   name: "Contact",
    //   selector: (row) => formInputs?.data[0]?.mobileNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Contact",
    //   selector: (row) => formInputs?.mobileNr ?? "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Contact",
      selector: (row) =>
        row?.Customer_InvoiceRegisterDocs?.salesOfficerContactNr
          ? row.Customer_InvoiceRegisterDocs?.salesOfficerContactNr
          : (formInputs?.mobileNr ?? "--"),
      sortable: true,
      width: "150px",
    },

    // {
    //   name: "Liters",
    //   selector: (row) => row.liters || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Total Amount",
      selector: (row) =>
        row.items?.[0]?.creditAmount || row.items?.[0]?.debitAmount || "--",
      cell: (row) => {
        const isCredit = row?.type?.toUpperCase() === "CREDIT";
        const amount =
          row.items?.[0]?.creditAmount || row.items?.[0]?.debitAmount || "--";

        return (
          <span
            className={`fw-bold ${isCredit ? "text-success" : "text-danger"}`}
          >
            {amount}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },

    {
      name: "Payment Mode",
      selector: (row) => row.transactionMode || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Type",
      selector: (row) => row.type || "--",
      cell: (row) => (
        <span
          className={`fw-bold ${
            row?.type?.toUpperCase() === "CREDIT"
              ? "text-success"
              : "text-danger"
          }`}
        >
          {row?.type || "--"}
        </span>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Remarks",
      selector: (row) => row.remarks || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Transaction",
      selector: (row) => row.transaction,
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Usage Reading",
    //   selector: (row) => row.usageReading,
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Mileage",
    //   selector: (row) => Number(row.mileage).toFixed(2),
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold">
    //         {Number(row.mileage).toFixed(2)}
    //       </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Attachments",
    //   selector: (row) => row.billDocument,
    //   cell: (row) => (
    //     <div
    //       style={{ width: "100%" }}
    //       className="d-flex justify-content-center"
    //     >
    //       {row.billDocument && (
    //         <img
    //           src="assets/img/newIcons/attached-file.png"
    //           className="mt-1 attachmentIcon"
    //           alt="attachments"
    //           onClick={() => handleViewFile(row.billDocument)}
    //         />
    //       )}
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "130px",
    // },
  ];

  const detailedPageInvoice = (invoiceNumber, transaction) => {
    if (!invoiceNumber || !transaction) {
      console.error("Missing invoice number or transaction.");
      return;
    }
    if (transaction === "PO" || transaction === "Purchase") {
      dispatch(purchaseNr(invoiceNumber));
      navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_DETAILS);
    } else if (transaction === "INV" || transaction === "Sales") {
      dispatch(addInvoiceID(invoiceNumber));
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_DETAILS);
    } else if (
      transaction === "BK" ||
      transaction === "Payment" ||
      transaction === "Receipt"
    ) {
      dispatch(bankStatements(invoiceNumber));
      navigate(CustomerConstants.CUSTOMER_V2_BANK_STATEMENT_DETAILS);
    } else if (transaction === "EK" || transaction === "Expenses") {
      dispatch(cashExpensesNr(invoiceNumber));
      navigate(CustomerConstants.CUSTOMER_V2_CASH_EXPENSES_DETAILS);
    } else {
      console.error("Invalid transaction type.");
    }
  };
  const typeLabels = {
    C05: "Driver Details",
    C06: "Employee Details",
    C07: "Office Boy Details",
    C08: "Sales Details",
    C09: "Others Details",
  };
  const iconTable = {
    C05: "DD",
    C06: "ED",
    C07: "OD",
    C08: "SD",
    C09: "OD",
  };
  const Labels = {
    C05: "Driver Name",
    C06: "Employee Name",
    C07: "Office Boy Name",
    C08: "Sales Name",
    C09: "Others Name",
  };

  const [pageConfigInfo, setPageConfigInfo] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, userData]);
  //bank update
  const bankInfoInitialData = {
    id: "",
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
    bankCurrency: "INR",
  };
  const removeBankForm = (indexToRemove) => {
    setBankDetails(
      getBankDetails.filter((form, index) => index !== indexToRemove),
    );
  };
  const addBankForm = () => {
    const uniqueId = Date.now().toString(); // or use uuid if you prefer
    const newForm = { ...bankInfoInitialData, id: uniqueId };
    setBankDetails([...getBankDetails, newForm]);
  };

  const [approvalLoading, setApprovalLoading] = useState(false);

  const isApprovalUser = userData?.userId === "A000";
  const isSalesOfficer = /^S\d+$/i.test(userData?.userId || "");
  const handleCustomerApproval = async (value) => {
    if (!["APPROVED", "REJECTED"].includes(value)) return;

    const isApproved = value === "APPROVED";

    const payload = {
      ...formInputs,
      activeInactive: isApproved,
      approveStatus: isApproved ? "Admin approved and verified" : "Rejected",
    };

    try {
      setApprovalLoading(true);

      const response = await ItemService.updateCustomerV1(payload);

      if (response?.status === 200) {
        setFormInputs((prev) => ({
          ...prev,
          activeInactive: isApproved,
          approveStatus: payload.approveStatus,
        }));

        toast.success(
          isApproved
            ? "Customer approved successfully"
            : "Customer rejected successfully",
        );
      } else {
        toast.error(response?.message || "Unable to update approval");
      }
    } catch (error) {
      console.error("Customer approval error:", error);
      toast.error("Unable to update customer approval");
    } finally {
      setApprovalLoading(false);
    }
  };
  return (
    <>
      <main className="dashboard main" id="main">
        <Layout />
        <Row className="justify-center subContent">
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                {/* Customer Details :{" "} */}
                {typeLabels[formInputs?.customerTypeCode] ||
                  "Customer Details"}{" "}
                :{" "}
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {customerID}
                </span>
                <span>
                  {formInputs?.activeInactive ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      Active
                    </span>
                  ) : (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      Inactive
                    </span>
                  )}
                </span>
              </h2>
              {/* <p className="subText">Customer Registration Information </p> */}
              <p className="subText">
                {typeLabels[formInputs?.customerTypeCode] || "Customer"}{" "}
                Registration Information
              </p>
              <hr />

              <div className="pageFooter mb-4">
                <Row>
                  {workflow?.workflow_record?.decision?.length > 0 && (
                    <Col xs={12} md={4} lg={4} className="text-left">
                      <button
                        className="btnBack"
                        onClick={() => navigateToWorkflow()}
                      >
                        <i className="bi bi-arrow-return-left"></i> Go Back
                      </button>
                    </Col>
                  )}
                  <Col xs={12} md={8} lg={8} className="text-right">
                    {workflow?.workflow_record?.decision?.length > 0 &&
                      workflow?.workflow_record?.decision?.map(
                        (item, index) => (
                          <button
                            className={
                              item === "Approve" || item === "Submit"
                                ? "btnCommon btn-approve"
                                : "btnCommon btn-danger"
                            }
                            onClick={() => showApproveModal(item)}
                            key={index}
                          >
                            <i
                              className={
                                item === "Approve" || item === "Submit"
                                  ? "bi bi-check2-circle"
                                  : "bi bi-x-circle"
                              }
                            ></i>{" "}
                            {item}
                          </button>
                        ),
                      )}
                  </Col>
                </Row>
              </div>
              {/* {JSON.stringify(workflow) !== "{}" && ( */}
              {JSON.stringify(workflow) === "{}" && (
                <Row className="mb-4">
                  {!editMode && (
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 8 }}
                      lg={{ span: 2, offset: 8 }}
                      className="text-left "
                      onClick={handleUpdate}
                    >
                      <button className="btn btnInfo" disabled={disabled}>
                        Update
                      </button>
                    </Col>
                  )}
                  {!editMode && (
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button
                        className="btnInfo btn-danger"
                        onClick={canelUpdate}
                        // disabled={disabled}
                      >
                        Cancel
                      </button>
                    </Col>
                  )}
                  {editMode && (
                    <Row>
                      <Col
                        xs={6}
                        md={{ span: 2, offset: 8 }}
                        lg={{ span: 2, offset: 8 }}
                        className="text-left"
                      >
                        {formInputs?.KYCIndicator === "KYC" && (
                          <>
                            <button className="btnInfo" onClick={handlePrint}>
                              <i className="bi bi-printer"></i> Print KYC
                            </button>
                            <div style={{ display: "none" }}>
                              {/* <PrintKYCRegistration
                              ref={contentRef}
                              data={formInputs}
                            /> */}
                            </div>
                          </>
                        )}
                      </Col>

                      <Col xs={6} md={2} lg={2} className="text-left">
                        <button className="btnInfo" onClick={editCustomer}>
                          Edit
                        </button>
                      </Col>
                    </Row>
                  )}
                </Row>
              )}
              <Loader isLoading={loading} className={"text-center"} />
              {!loading && (
                <>
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button align-items-center">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible9
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility9}
                            ></i>
                          </Col>

                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">T</span>
                          </Col>

                          <Col xs={6} md={7} lg={7}>
                            <span className="headerTitle">Tally </span>
                            <span className="subHeaderTitle">Details</span>
                          </Col>

                          <Col
                            xs={4}
                            md={3}
                            lg={3}
                            className="d-flex justify-content-end align-items-center"
                          >
                            {!updateTallyMode ? (
                              <button
                                type="button"
                                className="btn btnInfo tally-header-btn"
                                onClick={handleUpdateTally}
                                disabled={disabled}
                              >
                                Update Tally
                              </button>
                            ) : (
                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btnInfo tally-header-btn"
                                  disabled={disabled}
                                >
                                  Update
                                </button>

                                <button
                                  type="button"
                                  className="btn tally-header-btn tally-cancel-btn"
                                  onClick={handleCancelTally}
                                >
                                  Cancel
                                </button>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible9 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Tally Ref Nr"
                                extraLabel=""
                                name="tallyRefNr"
                                placeholder=""
                                value={formInputs?.tallyRefNr || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation.tallyRefNr}
                                disabled={!updateTallyMode}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                id="tallyEntryDate"
                                className="inputBox"
                                label="Entry Date"
                                name="tallyEntryDate"
                                placeholder=""
                                type="date"
                                value={formInputs?.tallyEntryDate || ""}
                                onChange={onInputChange}
                                disabled={!updateTallyMode}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Status"
                                placeholder=""
                                data={status}
                                id="tallyStatus"
                                iconClassName="dropdownIcon"
                                name="tallyStatus"
                                code="tallyStatusCode"
                                description="tallyStatusDesc"
                                setValue={formInputs?.tallyStatus}
                                getvalue={setDropdownData}
                                required={true}
                                disabled={!updateTallyMode}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                id="tallyRemark"
                                className="inputBox"
                                label="Remark"
                                name="tallyRemark"
                                placeholder=""
                                value={formInputs?.tallyRemark || ""}
                                onChange={onInputChange}
                                disabled={!updateTallyMode}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* customer details */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            {/* <span className="iconLogo">CD</span> */}
                            <span className="iconLogo">
                              {iconTable[formInputs?.customerTypeCode] || "CD"}
                            </span>
                          </Col>
                          <Col xs={8} md={8} lg={8}>
                            {/* <span className="headerTitle">Customer </span>
                          <span className="subHeaderTitle">
                            Customer Details
                          </span> */}
                            <span className="headerTitle">
                              {typeLabels[formInputs?.customerTypeCode] ||
                                "Customer"}
                            </span>
                            <span className="subHeaderTitle">
                              {typeLabels[formInputs?.customerTypeCode] ||
                                "Customer"}
                            </span>
                          </Col>
                        </Row>
                      </h2>
                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Customer Name"
                                label={
                                  Labels[formInputs?.customerTypeCode] ||
                                  "Customer Name"
                                }
                                extraLabel="As per the trade license"
                                name="organisationName"
                                placeholder=""
                                value={formInputs?.organisationName || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation.organisationName}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label=" Address Lines 1 / Street"
                                name="address"
                                placeholder=""
                                value={formInputs?.address || ""}
                                onChange={onInputChange}
                                error={validation.address}
                                required={true}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Address Line 2"
                                name="address2"
                                placeholder=""
                                value={formInputs?.address2 || ""}
                                onChange={onInputChange}
                                error={validation.address2}
                                required={true}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="City"
                                name="city"
                                placeholder=""
                                value={formInputs?.city || ""}
                                onChange={onInputChange}
                                error={validation.city}
                                required={true}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Country"
                                placeholder=""
                                data={getCountry}
                                id="country"
                                iconClassName="dropdownIcon"
                                name="country"
                                code="countryCode"
                                description="countryDesc"
                                setValue={formInputs?.country || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.country}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="State"
                                placeholder=""
                                data={getState}
                                id="state"
                                iconClassName="dropdownIcon"
                                name="state"
                                code="stateCode"
                                description="stateDesc"
                                setValue={formInputs?.state}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.state}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Postal Code/PO Box"
                                name="cityPostalCode"
                                placeholder=""
                                value={formInputs?.cityPostalCode}
                                onChange={onInputChange}
                                error={validation.cityPostalCode}
                                required={true}
                                disabled={editMode}
                              />
                            </Col>
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Sales Officer Name"
                                extraLabel=""
                                name="salesOfficerName"
                                code="salesOfficerCode"
                                description="salesOfficerDesc"
                                data={SalesOfficerData}
                                id="salesOfficerName"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.salesOfficerName}
                                error={validation.salesOfficerName}
                                getvalue={setDropdownData}
                                required={true}
                                // className="dropdownOption"
                                disabled={editMode}
                              />
                            </Col> */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Company Code"
                                extraLabel="SAP Company Code"
                                placeholder=""
                                data={getCompanyCode}
                                id="companyCode"
                                iconClassName="dropdownIcon"
                                name="companyCode"
                                code="companyCodeCode"
                                description="companyCodeDesc"
                                setValue={formInputs.companyCode || ""}
                                getvalue={setDropdownData}
                                onChange={onInputChange}
                                // error={validation.companyCode}
                                required={true}
                                disabled={editMode}
                              />
                            </Col>
                            {formInputs?.type !== "EMP" && (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="GST Nr"
                                  name="gstNumber"
                                  placeholder=""
                                  value={formInputs.gstNumber}
                                  error={validation.gstNumber}
                                  onChange={onInputChange}
                                  disabled={editMode}
                                />
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Category"
                                name="undercategory"
                                placeholder=""
                                value={formInputs.undercategory}
                                error={validation.undercategory}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Opening Balance"
                                name="openingBalance"
                                type="number"
                                placeholder=""
                                value={formInputs.openingBalance}
                                error={validation.openingBalance}
                                onChange={onInputChange}
                                disabled={editMode}
                              />
                            </Col>
                            {hasAccess(
                              userRole,
                              "buttons",
                              "customer_details_edit",
                              pageConfigInfo,
                            ) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="activeInactive"
                                  >
                                    Active/Inactive
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="activeInactive"
                                    id="activeInactive"
                                    checked={
                                      formInputs?.activeInactive || false
                                    }
                                    onChange={(e) =>
                                      setFormInputs((prev) => ({
                                        ...prev,
                                        activeInactive: e.target.checked,
                                      }))
                                    }
                                    disabled={editMode}
                                  />
                                  <span className="ms-2">
                                    {formInputs?.activeInactive
                                      ? "Active"
                                      : "Inactive"}
                                  </span>
                                </div>
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding d-flex align-items-center"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="activeInactive"
                                >
                                  Registered/Non Registered
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="registered_NonReg"
                                  id="registered_NonReg"
                                  checked={
                                    formInputs?.registered_NonReg || false
                                  }
                                  onChange={(e) =>
                                    setFormInputs((prev) => ({
                                      ...prev,
                                      registered_NonReg: e.target.checked,
                                    }))
                                  }
                                  disabled={editMode}
                                />
                                <span className="ms-2">
                                  {formInputs?.registered_NonReg
                                    ? "Registered"
                                    : "Non Registered"}
                                </span>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <label className="form-check-label fw-medium fs-6 text-dark mb-2">
                                Admin Approval
                              </label>

                              <select
                                className="form-select"
                                value={
                                  formInputs?.approveStatus ===
                                  "Admin approved and verified"
                                    ? "APPROVED"
                                    : formInputs?.approveStatus === "Rejected"
                                      ? "REJECTED"
                                      : "PENDING"
                                }
                                onChange={(e) =>
                                  handleCustomerApproval(e.target.value)
                                }
                                disabled={
                                  !isApprovalUser ||
                                  formInputs?.createdByCode === "A000" ||
                                  approvalLoading
                                }
                              >
                                <option value="PENDING">
                                  Pending Approval
                                </option>
                                <option value="APPROVED">Approved</option>
                                <option value="REJECTED">Rejected</option>
                              </select>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Sales Officer  */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible2
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility7}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SP</span>
                          </Col>
                          <Col xs={4} md={8} lg={8}>
                            <span className="headerTitle"> Sales Officer</span>
                            <span className="subHeaderTitle">
                              Sales Officer
                            </span>
                          </Col>
                          <Col xs={4} md={2} lg={2}>
                            <div className="d-flex justify-content-end  p-2 me-3">
                              <button
                                className="btnTable"
                                onClick={addSalesOfficer}
                              >
                                <i className="bi bi-plus-lg"></i> Add
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </h2>
                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible7 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="accordion-body">
                                <div className="d-flex-column justify-content-center">
                                  <Row>
                                    <Col xs={12}>
                                      <div className="accordion-body">
                                        <div className="d-flex-column justify-content-center">
                                          <Row className="pt-4 d-none d-lg-flex ">
                                            <Col xs={12} md={2} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Sales Officer
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Form Date
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                To Date
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Remarks
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex">
                                                Action
                                              </p>
                                            </Col>
                                          </Row>
                                          {getSalesOfficer.map((doc, index) => (
                                            <Row key={doc.id}>
                                              <Col xs={12}>
                                                <hr className="mx-4 my-0 text-color-black" />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <ComboboxField
                                                  label=""
                                                  placeholder="Sales Person Name"
                                                  data={SalesOfficerData}
                                                  id="salesOfficerName"
                                                  iconClassName="dropdownIcon"
                                                  name="salesOfficerName"
                                                  code="salesOfficerCode"
                                                  codeType="salesOfficerCode"
                                                  description="salesOfficerDesc"
                                                  setValue={
                                                    doc.salesOfficerName
                                                  }
                                                  getvalue={setDropdownData}
                                                  index={doc.id}
                                                  onChangeValue={
                                                    handleSalesOfficer
                                                  }
                                                  disabled={editMode}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  type="date"
                                                  value={doc.fromDate}
                                                  min="1900-01-01"
                                                  onChange={(e) =>
                                                    handleSalesOfficer(
                                                      doc.id,
                                                      "fromDate",
                                                      e.target.value,
                                                    )
                                                  }
                                                  disabled={editMode}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  type="date"
                                                  value={doc.toDate}
                                                  min="1900-01-01"
                                                  onChange={(e) =>
                                                    handleSalesOfficer(
                                                      doc.id,
                                                      "toDate",
                                                      e.target.value,
                                                    )
                                                  }
                                                  disabled={editMode}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <TextAreaField
                                                  className="inputBox mt-1"
                                                  name="remarks"
                                                  placeholder="Remarks"
                                                  value={doc.remarks || ""}
                                                  onChange={(e) =>
                                                    handleSalesOfficer(
                                                      doc.id,
                                                      "remarks",
                                                      e.target.value,
                                                    )
                                                  }
                                                  error={
                                                    validation[
                                                      `${doc.id}remarks`
                                                    ]
                                                  }
                                                  disabled={editMode}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                                              >
                                                <div className="form-check form-switch">
                                                  <input
                                                    className="form-check-input custom-switch"
                                                    type="checkbox"
                                                    role="switch"
                                                    name="activeInactive"
                                                    id={`salesOfficerActiveInactive${doc.id}`}
                                                    checked={
                                                      doc?.activeInactive ??
                                                      true
                                                    }
                                                    // disabled={editMode}
                                                    onChange={(e) =>
                                                      handleSalesOfficer(
                                                        doc.id,
                                                        "activeInactive",
                                                        e.target.checked,
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                  <span className="ms-2">
                                                    {doc?.activeInactive
                                                      ? "Active"
                                                      : "Inactive"}
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <i
                                                  onClick={() =>
                                                    deleteSalesOfficer(doc.id)
                                                  }
                                                  className="bi bi-trash text-danger fs-4"
                                                />
                                              </Col>
                                            </Row>
                                          ))}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Customer Contact Person / Line Item */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible2
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility2}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CP</span>
                          </Col>
                          <Col xs={4} md={8} lg={8}>
                            <span className="headerTitle"> Contact Person</span>
                            <span className="subHeaderTitle">
                              Contact Person
                            </span>
                          </Col>
                          {!editMode && (
                            <Col xs={4} md={2} lg={2}>
                              <div className="d-flex justify-content-end  p-2 me-3">
                                <button
                                  className="btnTable"
                                  onClick={addCustomerCantactPerson}
                                >
                                  <i className="bi bi-plus-lg"></i> Add
                                </button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </h2>
                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible2 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="accordion-body">
                                <div className="d-flex-column justify-content-center">
                                  <Row>
                                    <Col xs={12}>
                                      <div className="accordion-body">
                                        <div className="d-flex-column justify-content-center">
                                          <Row className="pt-4 d-none d-lg-flex ">
                                            <Col xs={12} md={2} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Job Title
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Contact Title
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Contact Person
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Contact Number
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Email-ID
                                              </p>
                                            </Col>
                                            {!editMode && (
                                              <Col xs={12} md={4} lg={2}>
                                                <p className="fs-6 fw-medium d-flex">
                                                  Action
                                                </p>
                                              </Col>
                                            )}
                                          </Row>
                                          {getcustomerContactPerson?.length >
                                            0 &&
                                            getcustomerContactPerson.map(
                                              (doc, index) => (
                                                <Row key={doc.id}>
                                                  <Col xs={12}>
                                                    <hr className="mx-4 my-0 text-color-black" />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <ComboboxField
                                                      label=""
                                                      placeholder="Contact Position"
                                                      data={getcontactPosition}
                                                      id="contactPosition"
                                                      codeType="jobtitle"
                                                      iconClassName="dropdownIcon"
                                                      name="contactPosition"
                                                      code="contactPositionCode"
                                                      description="contactPositionDesc"
                                                      // setValue={
                                                      //   doc?.contactPosition
                                                      // }
                                                      setValue={
                                                        doc?.contactPosition ||
                                                        doc?.contactPositionDesc
                                                      }
                                                      getvalue={setDropdownData}
                                                      index={doc.id}
                                                      onChangeValue={
                                                        handleChangeCustomerContacts
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <ComboboxField
                                                      label=""
                                                      placeholder="Contact Title"
                                                      data={getTitle}
                                                      id="contactTitle"
                                                      codeType="title"
                                                      iconClassName="dropdownIcon"
                                                      name="contactTitle"
                                                      code="contactTitleCode"
                                                      description="contactTitleDesc"
                                                      // setValue={
                                                      //   doc?.contactTitle
                                                      // }
                                                      setValue={
                                                        doc?.contactTitle ||
                                                        doc?.contactTitleDesc
                                                      }
                                                      getvalue={setDropdownData}
                                                      index={doc.id}
                                                      onChangeValue={
                                                        handleChangeCustomerContacts
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox mt-1"
                                                      name="contactName"
                                                      placeholder="Contact Person"
                                                      value={
                                                        doc.contactName || ""
                                                      }
                                                      onChange={(e) =>
                                                        handleChangeCustomerContacts(
                                                          doc.id,
                                                          "contactName",
                                                          e.target.value,
                                                        )
                                                      }
                                                      error={
                                                        validation[
                                                          `${doc.id}_contactName`
                                                        ]
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox mt-1"
                                                      name="contactNumber"
                                                      placeholder="Contact Number"
                                                      value={
                                                        doc.contactNumber || ""
                                                      }
                                                      onChange={(e) =>
                                                        handleChangeCustomerContacts(
                                                          doc.id,
                                                          "contactNumber",
                                                          e.target.value,
                                                        )
                                                      }
                                                      disabled={editMode}
                                                      error={
                                                        validation[
                                                          `${doc.id}_contactNumber`
                                                        ]
                                                      }
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox mt-1"
                                                      // label="Please Enter the Remarks*"
                                                      name="contactEmail"
                                                      placeholder="Email"
                                                      value={
                                                        doc.contactEmail || ""
                                                      }
                                                      onChange={(e) =>
                                                        handleChangeCustomerContacts(
                                                          doc.id,
                                                          "contactEmail",
                                                          e.target.value,
                                                        )
                                                      }
                                                      disabled={editMode}
                                                      error={
                                                        validation[
                                                          `${doc.id}_contactEmail`
                                                        ]
                                                      }
                                                    />
                                                  </Col>

                                                  {!editMode && (
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={1}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <i
                                                        onClick={() =>
                                                          deleteCustomerContactPerosn(
                                                            doc.id,
                                                          )
                                                        }
                                                        className="bi bi-trash text-danger fs-4"
                                                      />
                                                    </Col>
                                                  )}
                                                </Row>
                                              ),
                                            )}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* customer Doucment Type */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible3
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility3}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">DT</span>
                          </Col>
                          <Col xs={4} md={8} lg={8}>
                            <span className="headerTitle"> Doucment Type</span>
                            <span className="subHeaderTitle">
                              Doucment Type
                            </span>
                          </Col>
                          {!editMode && (
                            <Col xs={4} md={2} lg={2}>
                              <div className="d-flex justify-content-end  p-2 me-3">
                                <button
                                  className="btnTable"
                                  onClick={addDocumentType}
                                >
                                  <i className="bi bi-plus-lg"></i> Add
                                </button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </h2>
                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible3 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="accordion-body">
                                <div className="d-flex-column justify-content-center">
                                  <Row>
                                    <Col xs={12}>
                                      <div className="accordion-body">
                                        <div className="d-flex-column justify-content-center">
                                          <Row className="pt-4 d-none d-lg-flex ">
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Document Type
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Document Number
                                              </p>
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Issue Date
                                              </p>
                                            </Col>

                                            <Col xs={12} md={4} lg={1}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                View Files
                                              </p>
                                            </Col>

                                            {!editMode && (
                                              <>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Attachments
                                                  </p>
                                                </Col>

                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                                    Action
                                                  </p>
                                                </Col>
                                              </>
                                            )}
                                          </Row>
                                          {getDocumentTypeData?.length > 0 &&
                                            getDocumentTypeData.map(
                                              (doc, index) => (
                                                <Row key={doc.id}>
                                                  <Col xs={12}>
                                                    <hr className="mx-4 my-0 text-color-black" />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <ComboboxField
                                                      label=""
                                                      placeholder="Document type"
                                                      data={getdocumentType}
                                                      id="documentType"
                                                      codeType="documentType"
                                                      iconClassName="dropdownIcon"
                                                      name="documentType"
                                                      code="documentTypeCode"
                                                      description="documentTypeDesc"
                                                      // setValue={
                                                      //   doc?.documentType
                                                      // }
                                                      setValue={
                                                        doc?.documentType ||
                                                        doc?.documentTypeDesc
                                                      }
                                                      getvalue={setDropdownData}
                                                      index={doc.id}
                                                      onChangeValue={
                                                        handleInputChange
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      placeholder="Document Number"
                                                      value={doc.documentNumber}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          doc.id,
                                                          "documentNumber",
                                                          e.target.value,
                                                        )
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={2}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      type="date"
                                                      min="1900-01-01"
                                                      value={doc.issueDate}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          doc.id,
                                                          "issueDate",
                                                          e.target.value,
                                                        )
                                                      }
                                                      disabled={editMode}
                                                    />
                                                  </Col>

                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={1}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <div className="d-flex justify-content-center">
                                                      {doc.iSOCertification && (
                                                        <img
                                                          src="assets/img/newIcons/attached-file.png"
                                                          className="mt-1 attachmentIcon"
                                                          alt="attachments"
                                                          onClick={() =>
                                                            handleViewFile(
                                                              doc.iSOCertification,
                                                            )
                                                          }
                                                        />
                                                      )}
                                                    </div>
                                                  </Col>

                                                  {!editMode && (
                                                    <>
                                                      <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={3}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <FileUploadComponent
                                                          id={doc.id}
                                                          name="iSOCertification"
                                                          label=""
                                                          allowedTypes={[
                                                            "image/png",
                                                            "image/jpeg",
                                                            "application/pdf",
                                                          ]}
                                                          multiple={true} // Change to `false` for single file selection
                                                          required={true}
                                                          onSuccessUpload={
                                                            onSuccessUploadDocumentType
                                                          }
                                                          value={
                                                            formInputs.iSOCertification ||
                                                            ""
                                                          }
                                                          disabled={editMode}
                                                        />
                                                      </Col>

                                                      <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <i
                                                          onClick={() =>
                                                            deleteDocumentType(
                                                              doc.id,
                                                            )
                                                          }
                                                          className="bi bi-trash text-danger fs-4"
                                                        />
                                                      </Col>
                                                    </>
                                                  )}
                                                </Row>
                                              ),
                                            )}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* KYC Updated details */}
                  {formInputs?.KYCIndicator &&
                    formInputs?.KYCIndicator === "KYC" && (
                      <>
                        {/* Project Completed*/}
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-left arrowBtn"
                                >
                                  <i
                                    className={`bi ${
                                      isCardVisible11
                                        ? "bi-chevron-right"
                                        : "bi-chevron-down"
                                    }`}
                                    onClick={toggleCardVisibility11}
                                  ></i>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">FI</span>
                                </Col>
                                <Col xs={12} md={9} lg={9}>
                                  <span className="headerTitle">
                                    Project Completed
                                  </span>
                                  <span className="subHeaderTitle">
                                    Project Completed
                                  </span>
                                </Col>
                                {!editMode && (
                                  <Col
                                    xs={12}
                                    md={2}
                                    lg={2}
                                    className="headerButtonAlign"
                                  >
                                    <button
                                      className="btnTable"
                                      onClick={addProjecetDocumentItemRow}
                                    >
                                      <i className="bi bi-plus-lg"></i> Add
                                    </button>
                                  </Col>
                                )}

                                {/* <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col> */}
                              </Row>
                            </h2>

                            <div
                              className={`accordion-collapse collapse show ${
                                isCardVisible11 ? "visible" : ""
                              }`}
                            >
                              <div className="accordion-body">
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={projectCompletedCol}
                                    data={getprojectCompletedData}
                                    // progressPending={loading}
                                    // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                    pagination
                                    // paginationServer
                                    // paginationTotalRows={totalRows}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    // onChangePage={handlePageChange}
                                    // selectableRows
                                    // onSelectedRowsChange={handleChange}
                                  />
                                </Col>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Project on Hand*/}
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-left arrowBtn"
                                >
                                  <i
                                    className={`bi ${
                                      isCardVisible12
                                        ? "bi-chevron-right"
                                        : "bi-chevron-down"
                                    }`}
                                    onClick={toggleCardVisibility12}
                                  ></i>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">FI</span>
                                </Col>
                                <Col xs={12} md={9} lg={9}>
                                  <span className="headerTitle">
                                    Project on Hand
                                  </span>
                                  <span className="subHeaderTitle">
                                    Project on Hand
                                  </span>
                                </Col>
                                {!editMode && (
                                  <Col
                                    xs={12}
                                    md={2}
                                    lg={2}
                                    className="headerButtonAlign"
                                  >
                                    <button
                                      className="btnTable"
                                      onClick={
                                        addprojectDetailContactPersonItemRow
                                      }
                                    >
                                      <i className="bi bi-plus-lg"></i> Add
                                    </button>
                                  </Col>
                                )}

                                {/* <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col> */}
                              </Row>
                            </h2>

                            <div
                              className={`accordion-collapse collapse show ${
                                isCardVisible12 ? "visible" : ""
                              }`}
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col xs={12} md={12} lg={12}>
                                    <DataTable
                                      title=""
                                      columns={projectOnHandCol}
                                      data={getProjectOnHandData}
                                      // progressPending={loading}
                                      // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                      pagination
                                      // paginationServer
                                      // paginationTotalRows={totalRows}
                                      // onChangeRowsPerPage={handlePerRowsChange}
                                      // onChangePage={handlePageChange}
                                      // selectableRows
                                      // onSelectedRowsChange={handleChange}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* RichTextEditor */}
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-left arrowBtn"
                                >
                                  <i
                                    className={`bi ${
                                      isCardVisible6
                                        ? "bi-chevron-right"
                                        : "bi-chevron-down"
                                    }`}
                                    onClick={toggleCardVisibility6}
                                  ></i>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">RE</span>
                                </Col>
                                <Col xs={8} md={9} lg={9}>
                                  <span className="headerTitle">Remarks</span>
                                  <span className="subHeaderTitle">
                                    Remarks
                                  </span>
                                </Col>
                              </Row>
                            </h2>

                            <div
                              className={`accordion-collapse collapse show ${
                                isCardVisible6 ? "visible" : ""
                              }`}
                            >
                              <div className="accordion-body">
                                <Row className="p-4">
                                  <Col xs={12} md={12} lg={12}>
                                    <RichTextEditor
                                      value={getCustomerProfile}
                                      onChange={handleEditorChange}
                                      readOnly={editMode}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {/* 08 Banker Info*/}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible8
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility8}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">BI</span>
                          </Col>
                          <Col xs={12} md={8} lg={8}>
                            <span className="headerTitle">
                              Bank Information
                            </span>
                            <span className="subHeaderTitle">
                              Bank Information (Please add all your Bank
                              Accounts)
                            </span>
                          </Col>
                          {!editMode && (
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={() => addBankForm()}
                                // disabled={getDisabledStatus}
                              >
                                <i className="bi bi-plus-lg"></i> Add Bank Info
                              </button>
                            </Col>
                          )}
                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      {/* Banker Information */}
                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible8 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          {/* To Load Dynamic Bank Info Form */}
                          {getBankDetails &&
                            getBankDetails?.map((item, index) => (
                              <div key={item.id}>
                                <Row className="pt-2 pb-2">
                                  <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <h6>
                                      Bank Information Section {index + 1}
                                    </h6>
                                    {!editMode && (
                                      <span
                                        className="deleteIconAccordion"
                                        onClick={() => removeBankForm(index)}
                                      >
                                        {" "}
                                        <i className="bi bi-x-circle"></i>{" "}
                                      </span>
                                    )}
                                  </Col>
                                  {/*   <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Is the Company bank included on list?"
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col> */}

                                  {/*   <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="BankID"
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankKey`]
                                    : ""
                                }

                                // disabled={getDisabledStatus}
                              />
                            </Col> */}
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Bank IFSC ID"
                                      name="bankKey"
                                      placeholder=""
                                      value={item?.bankKey}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankKey",
                                          e.target.value,
                                        )
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Bank A/C Number"
                                      name="bankAccountNumber"
                                      placeholder=""
                                      value={item?.bankAccountNumber}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankAccountNumber",
                                          e.target.value,
                                        )
                                      }
                                      error={
                                        item.bankNotListed === "Yes"
                                          ? validation[
                                              `${item.id}_bankAccountNumber`
                                            ]
                                          : ""
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    {/* <ComboboxField
                                            label="Bank Name"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankName"
                                            iconClassName="dropdownIcon"
                                            name="bankName"
                                            setValue={item?.bankName || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}

                                    <InputField
                                      className="inputBox"
                                      label="Bank Name"
                                      name="bankBranchName"
                                      placeholder=""
                                      value={item?.bankBranchName}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankBranchName",
                                          e.target.value,
                                        )
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    {/* <ComboboxField
                                            label="Bank Country"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankCountry"
                                            iconClassName="dropdownIcon"
                                            name="bankCountry"
                                            setValue={item?.bankCountry || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                                    <InputField
                                      className="inputBox"
                                      label="Bank Country"
                                      name="bankCountryDescription"
                                      placeholder=""
                                      value={item?.bankCountryDescription}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankCountryDescription",
                                          e.target.value,
                                        )
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    {/* <ComboboxField
                                            label="Branch Address"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankAddress"
                                            iconClassName="dropdownIcon"
                                            name="bankAddress"
                                            setValue={item?.bankAddress || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                                    <InputField
                                      className="inputBox"
                                      label="Branch Address"
                                      name="bankAddress"
                                      placeholder=""
                                      value={item?.bankAddress}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankAddress",
                                          e.target.value,
                                        )
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    {/* <ComboboxField
                                            label="Preferred Currency"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="preferredCurrency"
                                            iconClassName="dropdownIcon"
                                            name="preferredCurrency"
                                            setValue={item?.preferredCurrency || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                                    <InputField
                                      className="inputBox"
                                      label="Preferred Currency"
                                      name="bankCurrency"
                                      placeholder=""
                                      value={item?.bankCurrency}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "bankCurrency",
                                          e.target.value,
                                        )
                                      }
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Name of Beneficiary"
                                      extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                      name="AccountHolderName"
                                      placeholder=""
                                      value={item?.AccountHolderName}
                                      onChange={(e) =>
                                        handleChangeBankInfo(
                                          item.id,
                                          "AccountHolderName",
                                          e.target.value,
                                        )
                                      }
                                      error={
                                        item.bankNotListed === "Yes"
                                          ? validation[
                                              `${item.id}_AccountHolderName`
                                            ]
                                          : ""
                                      }
                                      disabled={editMode}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <ComboboxField
                                      label="IFSC Code"
                                      placeholder=""
                                      data={dropdownOption}
                                      id="swiftIfscCode"
                                      iconClassName="dropdownIcon"
                                      name="swiftIfscCode"
                                      setValue={item?.swiftIfscCode || ""}
                                      getvalue={setDropdownData}
                                      index={item.id}
                                      onChangeValue={handleChangeBankInfo}
                                      disabled={editMode}
                                    />
                                  </Col>
                                  <Row>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding d-flex"
                                    >
                                      <FileUploadComponent
                                        id="bankCompanyletterhead"
                                        name="bankCompanyletterhead"
                                        label="Company letterhead"
                                        allowedTypes={[
                                          "image/png",
                                          "image/jpeg",
                                          "application/pdf",
                                        ]}
                                        multiple={true} // Change to false for single file selection
                                        required={true}
                                        onSuccessUpload={(data) =>
                                          onSuccessUploadBankDocumentType(
                                            data,
                                            index,
                                          )
                                        }
                                        value={
                                          item?.bankCompanyletterhead || ""
                                        }
                                      />

                                      <div className="d-flex align-items-center pe-2">
                                        {(item?.bankCompanyletterhead && (
                                          <img
                                            src="assets/img/newIcons/attached-file.png"
                                            className="mt-1 attachmentIcon"
                                            alt="attachments"
                                            onClick={() =>
                                              handleViewFile(
                                                item?.bankCompanyletterhead,
                                              )
                                            }
                                          />
                                        )) ||
                                          "--"}
                                      </div>
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding d-flex"
                                    >
                                      <FileUploadComponent
                                        id="bankConfirmationLetter"
                                        name="bankConfirmationLetter"
                                        label="Confirmation letter"
                                        allowedTypes={[
                                          "image/png",
                                          "image/jpeg",
                                          "application/pdf",
                                        ]}
                                        multiple={true} // Change to false for single file selection
                                        required={true}
                                        onSuccessUpload={(data) =>
                                          onSuccessUploadBankDocumentType(
                                            data,
                                            index,
                                          )
                                        }
                                        value={
                                          item?.bankConfirmationLetter || ""
                                        }
                                      />

                                      <div className="d-flex align-items-center pe-2">
                                        {(item?.bankConfirmationLetter && (
                                          <img
                                            src="assets/img/newIcons/attached-file.png"
                                            className="mt-1 attachmentIcon"
                                            alt="attachments"
                                            onClick={() =>
                                              handleViewFile(
                                                item?.bankConfirmationLetter,
                                              )
                                            }
                                          />
                                        )) ||
                                          "--"}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <hr />
                                  </Col>
                                </Row>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {formInputs?.Customer_InvoiceRegisterDocs &&
                    formInputs?.Customer_InvoiceRegisterDocs.length > 0 && (
                      <>
                        {/* Transaction History */}
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-left arrowBtn"
                                >
                                  <i
                                    className={`bi ${
                                      isCardVisible3
                                        ? "bi-chevron-right"
                                        : "bi-chevron-down"
                                    }`}
                                    onClick={toggleCardVisibility3}
                                  ></i>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">TH</span>
                                </Col>
                                <Col xs={12} md={8} lg={8}>
                                  <span className="headerTitle">
                                    Transaction History
                                  </span>
                                  <span className="subHeaderTitle">
                                    Transaction History Details{" "}
                                  </span>
                                </Col>

                                {/* <Col xs={2} md={1} lg={1} className="">
                                                                  <POCollabrationCommonFillter />
                                                                </Col> */}
                              </Row>
                            </h2>

                            <div
                              // id="acc"
                              className={`accordion-collapse collapse show ${
                                isCardVisible3 ? "visible" : ""
                              }`}
                              // aria-labelledby="headingOne"
                              // data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col xs={12} md={12} lg={12}>
                                    <DataTable
                                      title=""
                                      columns={fuelHistoryColum}
                                      data={getFuelHistory}
                                      // progressPending={loading}
                                      // paginationRowsPerPageOptions={
                                      //   Constants.ROW_PER_PAGE
                                      // }
                                      pagination
                                      // paginationServer
                                      // paginationTotalRows={totalRows}
                                      // onChangeRowsPerPage={handlePerRowsChange}
                                      // onChangePage={handlePageChange}
                                      selectableRows
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {/* Company Profile */}
                  {/* Company Profile */}
                  <div className="accordion mb-4" id="accordionCreditLimit">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible3
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility3}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CL</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">
                              Customer Credit Limit
                            </span>
                            <span className="subHeaderTitle">
                              Credit Limit Details
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible3 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <div className="mt-3 mb-4">
                              <div
                                className="card border-0 shadow-sm"
                                style={{
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                }}
                              >
                                {/* Header */}
                                <div
                                  className="px-3 py-2 d-flex justify-content-between align-items-center"
                                  style={{
                                    background: creditExceeded
                                      ? "#fff1f2"
                                      : "#f8fafc",
                                    borderBottom: "1px solid #e5e7eb",
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <div
                                      style={{
                                        width: "34px",
                                        height: "34px",
                                        borderRadius: "8px",
                                        background: creditExceeded
                                          ? "#fee2e2"
                                          : "#e0f2fe",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <i
                                        className={`bi ${
                                          creditExceeded
                                            ? "bi-exclamation-triangle"
                                            : "bi-credit-card"
                                        }`}
                                        style={{
                                          fontSize: "17px",
                                          color: creditExceeded
                                            ? "#dc2626"
                                            : "#0369a1",
                                        }}
                                      />
                                    </div>

                                    <div>
                                      <div
                                        style={{
                                          fontSize: "16px",
                                          color: "#6b7280",
                                        }}
                                      >
                                        Credit availability
                                      </div>
                                    </div>
                                  </div>

                                  {creditLoading && (
                                    <div className="d-flex align-items-center gap-2">
                                      <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                      />
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "#6b7280",
                                        }}
                                      >
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </div>

                                {/* Body */}
                                <div className="p-3">
                                  {creditError ? (
                                    <div className="alert alert-danger mb-0 py-2">
                                      <i className="bi bi-exclamation-circle me-2" />
                                      {creditError}
                                    </div>
                                  ) : customerCredit ? (
                                    <>
                                      <div className="row g-3">
                                        {/* Credit Limit */}
                                        <div className="col-md-3">
                                          <div
                                            className="p-3 h-100"
                                            style={{
                                              background: "#f8fafc",
                                              borderRadius: "10px",
                                              border: "1px solid #e5e7eb",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "11px",
                                                color: "#6b7280",
                                              }}
                                            >
                                              Credit Limit
                                            </div>

                                            <div
                                              className="mt-1"
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#111827",
                                              }}
                                            >
                                              ₹{creditLimit.toFixed(2)}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Outstanding */}
                                        <div className="col-md-3">
                                          <div
                                            className="p-3 h-100"
                                            style={{
                                              background: "#fff7ed",
                                              borderRadius: "10px",
                                              border: "1px solid #fed7aa",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "11px",
                                                color: "#9a3412",
                                              }}
                                            >
                                              Outstanding
                                            </div>

                                            <div
                                              className="mt-1"
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#c2410c",
                                              }}
                                            >
                                              ₹{outstanding.toFixed(2)}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Open Orders */}
                                        <div className="col-md-3">
                                          <div
                                            className="p-3 h-100"
                                            style={{
                                              background: "#eff6ff",
                                              borderRadius: "10px",
                                              border: "1px solid #bfdbfe",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "11px",
                                                color: "#1d4ed8",
                                              }}
                                            >
                                              Open Orders
                                            </div>

                                            <div
                                              className="mt-1"
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#1d4ed8",
                                              }}
                                            >
                                              ₹{openOrders.toFixed(2)}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Advance */}
                                        <div className="col-md-3">
                                          <div
                                            className="p-3 h-100"
                                            style={{
                                              background: "#f0fdf4",
                                              borderRadius: "10px",
                                              border: "1px solid #bbf7d0",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "11px",
                                                color: "#166534",
                                              }}
                                            >
                                              Advance
                                            </div>

                                            <div
                                              className="mt-1"
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#15803d",
                                              }}
                                            >
                                              ₹
                                              {Number(
                                                customerCredit?.advance ?? 0,
                                              ).toFixed(2)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Bottom Credit Summary */}
                                      <div
                                        className="mt-3 p-3 d-flex justify-content-between align-items-center"
                                        style={{
                                          borderRadius: "10px",
                                          background: creditExceeded
                                            ? "#fef2f2"
                                            : "#f0fdf4",
                                          border: `1px solid ${
                                            creditExceeded
                                              ? "#fecaca"
                                              : "#bbf7d0"
                                          }`,
                                        }}
                                      >
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#6b7280",
                                            }}
                                          >
                                            Credit Available
                                          </div>

                                          <div
                                            style={{
                                              fontSize: "22px",
                                              fontWeight: 700,
                                              color: creditExceeded
                                                ? "#dc2626"
                                                : "#15803d",
                                            }}
                                          >
                                            ₹{creditAvailable.toFixed(2)}
                                          </div>
                                        </div>

                                        <div className="text-end">
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#6b7280",
                                            }}
                                          >
                                            Credit Days
                                          </div>

                                          <div
                                            style={{
                                              fontSize: "16px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {customerCredit?.creditDays ?? 0}{" "}
                                            Days
                                          </div>
                                        </div>

                                        <div>
                                          {creditExceeded ? (
                                            <span className="badge bg-danger px-3 py-2">
                                              <i className="bi bi-x-circle me-1" />
                                              Credit Exceeded
                                            </span>
                                          ) : (
                                            <span className="badge bg-success px-3 py-2">
                                              <i className="bi bi-check-circle me-1" />
                                              Credit Available
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      className="text-center py-3"
                                      style={{
                                        color: "#6b7280",
                                        fontSize: "13px",
                                      }}
                                    >
                                      Credit details not available
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 08 Dealer Information */}
                  {!isSalesOfficer && (
                    <div
                      className="accordion mb-4"
                      id="accordionDealerInformation"
                    >
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible8
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility8}
                              ></i>
                            </Col>

                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">DI</span>
                            </Col>

                            <Col xs={12} md={8} lg={8}>
                              <span className="headerTitle">
                                Dealer Information
                              </span>

                              <span className="subHeaderTitle">
                                Dealer Information
                              </span>
                            </Col>

                            {!editMode && (
                              <Col xs={12} md={2} lg={2} className="text-end">
                                <button
                                  type="button"
                                  className="btnTable"
                                  onClick={addDealer}
                                >
                                  <i className="bi bi-plus-lg"></i> Add Dealer
                                </button>
                              </Col>
                            )}

                            {/* {editMode && (
                            <Col xs={12} md={2} lg={2} className="text-end">
                              <span className="text-muted">
                                {formInputs?.delarDetails?.length || 0} Dealer
                                {formInputs?.delarDetails?.length === 1
                                  ? ""
                                  : "s"}
                              </span>
                            </Col>
                          )} */}
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible8 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            {formInputs?.delarDetails?.length > 0 ? (
                              formInputs.delarDetails.map((item, index) => (
                                <div key={item.id || index}>
                                  <Row className="pt-2 pb-2">
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <h6>
                                        Dealer Information Section {index + 1}
                                        {!editMode && (
                                          <span
                                            className="deleteIconAccordion"
                                            onClick={() => removeDealer(index)}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i className="bi bi-x-circle"></i>
                                          </span>
                                        )}
                                      </h6>
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Dealer Name"
                                        name="delarName"
                                        value={item?.delarName || ""}
                                        disabled={editMode}
                                        onChange={(e) =>
                                          handleDealerChange(
                                            index,
                                            "delarName",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <TextAreaField
                                        className="inputBox"
                                        label="Dealer Address"
                                        name="delarAddress"
                                        value={item?.delarAddress || ""}
                                        disabled={editMode}
                                        onChange={(e) =>
                                          handleDealerChange(
                                            index,
                                            "delarAddress",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Dealer Pin Code"
                                        name="delarPinCode"
                                        value={item?.delarPinCode || ""}
                                        disabled={editMode}
                                        onChange={(e) =>
                                          handleDealerChange(
                                            index,
                                            "delarPinCode",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Contact Name"
                                        name="delarContactName"
                                        value={item?.delarContactName || ""}
                                        disabled={editMode}
                                        onChange={(e) =>
                                          handleDealerChange(
                                            index,
                                            "delarContactName",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Contact Number"
                                        name="delarContactNumber"
                                        value={item?.delarContactNumber || ""}
                                        disabled={editMode}
                                        onChange={(e) =>
                                          handleDealerChange(
                                            index,
                                            "delarContactNumber",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding d-flex align-items-center"
                                    >
                                      <div>
                                        <label
                                          className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                          htmlFor={`dealerActiveInactive_${
                                            item.id || index
                                          }`}
                                        >
                                          Active/Inactive
                                        </label>
                                      </div>

                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input custom-switch"
                                          type="checkbox"
                                          role="switch"
                                          name="activeInactive"
                                          id={`dealerActiveInactive_${
                                            item.id || index
                                          }`}
                                          checked={
                                            item?.activeInactive || false
                                          }
                                          disabled={editMode}
                                          onChange={(e) =>
                                            handleDealerChange(
                                              index,
                                              "activeInactive",
                                              e.target.checked,
                                            )
                                          }
                                        />

                                        <span className="ms-2">
                                          {item?.activeInactive
                                            ? "Active"
                                            : "Inactive"}
                                        </span>
                                      </div>
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <hr />
                                    </Col>
                                  </Row>
                                </div>
                              ))
                            ) : (
                              <div className="text-center py-3">
                                <span className="text-muted">
                                  No Dealer Information Available
                                </span>

                                {!editMode && (
                                  <div className="mt-3">
                                    <button
                                      type="button"
                                      className="btnTable"
                                      onClick={addDealer}
                                    >
                                      <i className="bi bi-plus-lg"></i> Add
                                      Dealer
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Financial Turnover */}
                  {!isSalesOfficer &&
                    !["C05", "C06", "C07", "C08", "C09"].includes(
                      formInputs?.customerTypeCode,
                    ) && (
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible5
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility5}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">FT</span>
                              </Col>
                              <Col xs={4} md={8} lg={8}>
                                <span className="headerTitle">
                                  {" "}
                                  Financial Turnover
                                </span>
                                <span className="subHeaderTitle">
                                  Please provide your company's turnover for the
                                  previous years, supported by documentary
                                  evidence
                                </span>
                              </Col>
                              {/* {!editMode && (
                                <Col xs={4} md={2} lg={2}>
                                  <div className="d-flex justify-content-end  p-2 me-3">
                                    <button
                                      className="btnTable"
                                      onClick={addFinancialTurnover}
                                    >
                                      <i className="bi bi-plus-lg"></i> Add
                                    </button>
                                  </div>
                                </Col>
                              )} */}
                            </Row>
                          </h2>
                          <div
                            // id="acc"
                            className={`accordion-collapse collapse show ${
                              isCardVisible5 ? "visible" : ""
                            }`}
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <div className="accordion-body">
                                    <div className="d-flex-column justify-content-center">
                                      <Row>
                                        <Col xs={12}>
                                          <div className="accordion-body">
                                            <div className="d-flex-column justify-content-center">
                                              <Row className="pt-4 d-none d-lg-flex ">
                                                <Col xs={12} md={2} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Financial Year
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={2} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Turnover Value
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={2} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Lakhs/Crore
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={3} lg={3}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    File View
                                                  </p>
                                                </Col>
                                                {!editMode && (
                                                  <>
                                                    <Col xs={12} md={2} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Attachments
                                                      </p>
                                                    </Col>

                                                    <Col xs={12} md={1} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex justify-content-start ms-4">
                                                        Delete
                                                      </p>
                                                    </Col>
                                                  </>
                                                )}
                                              </Row>
                                              {getFinancialTurnover.map(
                                                (doc, index) => (
                                                  <Row key={doc.id}>
                                                    <Col xs={12}>
                                                      <hr className="mx-4 my-0 text-color-black" />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={2}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <ComboboxField
                                                        label=""
                                                        placeholder="Financial Year"
                                                        data={dropDownYear}
                                                        id="turnoverYear"
                                                        iconClassName="dropdownIcon"
                                                        name="turnoverYear"
                                                        code="turnoverYearCode"
                                                        description="turnoverYearDesc"
                                                        setValue={
                                                          doc?.turnoverYear
                                                        }
                                                        getvalue={
                                                          setDropdownData
                                                        }
                                                        index={doc.id}
                                                        onChangeValue={
                                                          handleChangeFinancialTurnover
                                                        }
                                                        disabled={editMode}
                                                      />
                                                    </Col>

                                                    <Col
                                                      xs={12}
                                                      md={2}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        className="inputBox mt-1"
                                                        name="valueTurnover"
                                                        placeholder="Turnover Value"
                                                        value={
                                                          doc.valueTurnover ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleChangeFinancialTurnover(
                                                            doc.id,
                                                            "valueTurnover",
                                                            e.target.value,
                                                          )
                                                        }
                                                        disabled={editMode}
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={2}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <ComboboxField
                                                        label=""
                                                        placeholder="lakhs/Crore"
                                                        data={dropDownLackCrore}
                                                        id="lakhsCroreTurnover"
                                                        iconClassName="dropdownIcon"
                                                        name="lakhsCroreTurnover"
                                                        code="lakhsCroreTurnoverCode"
                                                        description="lakhsCroreTurnoverDesc"
                                                        setValue={
                                                          doc?.lakhsCroreTurnover
                                                        }
                                                        getvalue={
                                                          setDropdownData
                                                        }
                                                        index={doc.id}
                                                        onChangeValue={
                                                          handleChangeFinancialTurnover
                                                        }
                                                        disabled={editMode}
                                                      />
                                                    </Col>

                                                    <Col
                                                      xs={12}
                                                      md={2}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                          handleViewFile(
                                                            doc.financialTurnoverFileAttachment,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    {!editMode && (
                                                      <>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <FileUploadComponent
                                                            id="financialTurnoverFileAttachment"
                                                            name="financialTurnoverFileAttachment"
                                                            label=""
                                                            allowedTypes={[
                                                              "image/png",
                                                              "image/jpeg",
                                                              "application/pdf",
                                                            ]}
                                                            multiple={true} // Change to false for single file selection
                                                            required={true}
                                                            onSuccessUpload={
                                                              onSuccessUploadDocumentType
                                                            }
                                                            value={
                                                              doc.financialTurnoverFileAttachment ||
                                                              ""
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding "
                                                        >
                                                          <i
                                                            onClick={() =>
                                                              deleteFinancialTurnover(
                                                                doc.id,
                                                              )
                                                            }
                                                            className="bi bi-trash text-danger fs-4"
                                                          />
                                                        </Col>
                                                      </>
                                                    )}
                                                  </Row>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {/* Project Details*/}
                  {/* {!["C05", "C06", "C07", "C08", "C09"].includes(
                    formInputs?.customerTypeCode,
                  ) && (
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible4
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility4}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">SD</span>
                            </Col>
                            <Col xs={8} md={8} lg={8}>
                              <span className="headerTitle">Ship-to-Party</span>
                              <span className="subHeaderTitle">
                                Ship-to-Party Details
                              </span>
                            </Col>
                            {!editMode && (
                              <Col xs={4} md={2} lg={2}>
                                <div className="d-flex justify-content-end  p-2 me-3">
                                  <button
                                    className="btnTable"
                                    onClick={() => addProjectDetails()}
                                  >
                                    <i className="bi bi-plus-lg"></i> Add
                                  </button>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </h2>
                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible4 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            {getProjectDetails?.length > 0 &&
                              getProjectDetails?.map((item, index) => (
                                <div key={index}>
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                                        Ship-to-Party {index + 1}
                                      </h5>
                                      <span
                                        className="deleteIconAccordion"
                                        onClick={() =>
                                          removeProjectDetails(index)
                                        }
                                      >
                                        {" "}
                                        <i className="bi bi-x-circle"></i>{" "}
                                      </span>
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Project Name"
                                        extraLabel="As per the trade license"
                                        name="projectName"
                                        value={item.projectName || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectName",
                                          )
                                        }
                                        required={true}
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Address Lines 1 / Street"
                                        extraLabel="As per the trade license"
                                        name="projectAddress"
                                        value={item.projectAddress || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectAddress",
                                          )
                                        }
                                        required={true}
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Address Line 2"
                                        extraLabel="As per the trade license"
                                        name="projectAddress2"
                                        value={item.projectAddress2 || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectAddress2",
                                          )
                                        }
                                        required={true}
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="City"
                                        extraLabel="As per the trade license"
                                        name="projectCity"
                                        value={item.projectCity || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectCity",
                                          )
                                        }
                                        required={true}
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <ComboboxField
                                        label="Country"
                                        placeholder=""
                                        data={getCountry}
                                        id="projectCountry"
                                        iconClassName="dropdownIcon"
                                        name="projectCountry"
                                        code="projectCountryCode"
                                        description="projectCountryDesc"
                                        setValue={item?.projectCountry}
                                        getvalue={setDropdownData}
                                        index={item.id}
                                        onChangeValue={(value) =>
                                          handleProjectInputChange(
                                            value,
                                            index,
                                            "projectCountry",
                                          )
                                        }
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <ComboboxField
                                        label="State"
                                        placeholder=""
                                        data={getState}
                                        id="projectState"
                                        iconClassName="dropdownIcon"
                                        name="projectState"
                                        code="projectStateCode"
                                        description="projectStateDesc"
                                        setValue={item?.projectState}
                                        getvalue={setDropdownData}
                                        index={item.id}
                                        onChangeValue={(value) =>
                                          handleProjectInputChange(
                                            value,
                                            index,
                                            "projectState",
                                          )
                                        }
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Postal Code/PO Box"
                                        extraLabel="As per the trade license"
                                        name="projectCityPostalCode"
                                        value={item.projectCityPostalCode || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectCityPostalCode",
                                          )
                                        }
                                        required={true}
                                        disabled={editMode}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <ComboboxField
                                        label="Commission"
                                        placeholder=""
                                        data={dropdownOption}
                                        id="commission"
                                        iconClassName="dropdownIcon"
                                        name="commission"
                                        code="commissionCode"
                                        description="commissionDesc"
                                        setValue={item?.commission}
                                        getvalue={setDropdownData}
                                        index={item.id}
                                        onChangeValue={(value) =>
                                          handleProjectInputChange(
                                            value,
                                            index,
                                            "commission",
                                          )
                                        }
                                        disabled={editMode}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Commission Amount"
                                        name="commissionRate"
                                        placeholder=""
                                        // value={formInputs.commissionRate || ""}
                                        // onChange={onInputChange}
                                        // error={validation.commissionRate}
                                        required={true}
                                        value={item.commissionRate || ""}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "commissionRate",
                                          )
                                        }
                                        disabled={editMode}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                                Project Contacts
                                              </h5>
                                            </Col>

                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    <Col xs={12} md={2} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Job Title
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Title
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Person
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Number
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Email-ID
                                                      </p>
                                                    </Col>
                                                    {!editMode && (
                                                      <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={2}
                                                      >
                                                        <p className="fs-6 fw-medium d-flex">
                                                          Action
                                                        </p>
                                                      </Col>
                                                    )}
                                                  </Row>
                                                  {item.getProjectContactPerson &&
                                                    item.getProjectContactPerson
                                                      .length > 0 &&
                                                    item?.getProjectContactPerson.map(
                                                      (doc, itemIndex) => (
                                                        <Row key={doc.id}>
                                                          <Col xs={12}>
                                                            <hr className="mx-4 my-0 text-color-black" />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Select a position"
                                                              data={
                                                                getcontactPosition
                                                              }
                                                              id="projectContactPosition"
                                                              name="projectContactPosition"
                                                              code="projectContactPositionCode"
                                                              description="projectContactPositionDesc"
                                                              setValue={
                                                                doc.projectContactPosition
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                contactId,
                                                                fieldName,
                                                                value,
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Document type"
                                                              data={getTitle}
                                                              id="projectContactTitle"
                                                              iconClassName="dropdownIcon"
                                                              name="projectContactTitle"
                                                              code="projectContactTitleCode"
                                                              description="projectContactTitleDesc"
                                                              setValue={
                                                                doc.projectContactTitle
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                contactId,
                                                                fieldName,
                                                                value,
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactName"
                                                              placeholder="Contact Person"
                                                              value={
                                                                doc.projectContactName ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactName",
                                                                  e.target
                                                                    .value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactNumber"
                                                              placeholder="Contact Number"
                                                              value={
                                                                doc.projectContactNumber ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactNumber",
                                                                  e.target
                                                                    .value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactEmail"
                                                              placeholder="Email"
                                                              value={
                                                                doc.projectContactEmail ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactEmail",
                                                                  e.target
                                                                    .value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>
                                                          {!editMode && (
                                                            <Col
                                                              xs={12}
                                                              md={4}
                                                              lg={2}
                                                              className="commTopButtonRightLeftPadding"
                                                            >
                                                              <div className="d-flex">
                                                                {item
                                                                  ?.getProjectContactPerson
                                                                  .length !==
                                                                  1 && (
                                                                  <i
                                                                    onClick={() =>
                                                                      deleteProjectContactPerosnNew(
                                                                        index,
                                                                        doc.id,
                                                                      )
                                                                    }
                                                                    className="bi bi-trash text-danger fs-4"
                                                                  />
                                                                )}

                                                                {itemIndex ===
                                                                  item
                                                                    ?.getProjectContactPerson
                                                                    .length -
                                                                    1 && (
                                                                  <button
                                                                    className="btnTable width-40 ml-6 mt-1"
                                                                    onClick={() =>
                                                                      addProjectCantactPersonNew(
                                                                        index,
                                                                      )
                                                                    } // Fixed: Pass as a callback
                                                                  >
                                                                    <i className="bi bi-plus-lg"></i>{" "}
                                                                    Add
                                                                  </button>
                                                                )}
                                                              </div>
                                                            </Col>
                                                          )}
                                                        </Row>
                                                      ),
                                                    )}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Project Stages
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    <Col xs={12} md={2} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Stages
                                                      </p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        View Files
                                                      </p>
                                                    </Col>

                                                    {!editMode && (
                                                      <>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={3}
                                                        >
                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                            Attachments
                                                          </p>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={3}
                                                        >
                                                          <p className="fs-6 fw-medium d-flex">
                                                            Action
                                                          </p>
                                                        </Col>
                                                      </>
                                                    )}
                                                  </Row>
                                                  {item.getProjectCertifications &&
                                                    item
                                                      .getProjectCertifications
                                                      .length > 0 &&
                                                    item.getProjectCertifications.map(
                                                      (doc, itemIndex) => (
                                                        <Row key={doc.id}>
                                                          <Col xs={12}>
                                                            <hr className="mx-4 my-0 text-color-black" />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Stages"
                                                              data={
                                                                productDocumentAttachment
                                                              }
                                                              id="documentType"
                                                              iconClassName="dropdownIcon"
                                                              name="documentType"
                                                              code="documentTypeCode"
                                                              description="documentTypeDesc"
                                                              setValue={
                                                                doc.documentType
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                fileId,
                                                                fieldName,
                                                                value,
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value,
                                                                )
                                                              }
                                                              disabled={
                                                                editMode
                                                              }
                                                            />
                                                          </Col>

                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={1}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <div className="d-flex justify-content-center">
                                                              {doc.stageDocument && (
                                                                <img
                                                                  src="assets/img/newIcons/attached-file.png"
                                                                  className="mt-1 attachmentIcon"
                                                                  alt="attachments"
                                                                  onClick={() =>
                                                                    handleViewFile(
                                                                      doc.stageDocument,
                                                                    )
                                                                  }
                                                                />
                                                              )}
                                                            </div>
                                                          </Col>

                                                          {!editMode && (
                                                            <>
                                                              <Col
                                                                xs={12}
                                                                md={4}
                                                                lg={3}
                                                                className="commTopButtonRightLeftPadding"
                                                              >
                                                                <FileUploadComponent
                                                                  id={doc.id}
                                                                  name="stageDocument"
                                                                  label=""
                                                                  allowedTypes={[
                                                                    "image/png",
                                                                    "image/jpeg",
                                                                    "application/pdf",
                                                                  ]}
                                                                  multiple={
                                                                    true
                                                                  } // Change to `false` for single file selection
                                                                  required={
                                                                    true
                                                                  }
                                                                  onSuccessUpload={(
                                                                    data,
                                                                  ) =>
                                                                    onSuccessUploadProjectDocumentType(
                                                                      index,
                                                                      doc.id,
                                                                      data.fieldName,
                                                                      data.attachmentId,
                                                                    )
                                                                  }
                                                                  value={
                                                                    formInputs.stageDocument ||
                                                                    ""
                                                                  }
                                                                  disabled={
                                                                    editMode
                                                                  }
                                                                />
                                                              </Col>

                                                              <Col
                                                                xs={12}
                                                                md={4}
                                                                lg={2}
                                                                className="commTopButtonRightLeftPadding"
                                                              >
                                                                <div className="d-flex">
                                                                  {item
                                                                    ?.getProjectCertifications
                                                                    .length !==
                                                                    1 && (
                                                                    <i
                                                                      onClick={() =>
                                                                        deleteProjectCertifications(
                                                                          index,
                                                                          doc.id,
                                                                        )
                                                                      }
                                                                      className="bi bi-trash text-danger fs-4"
                                                                    />
                                                                  )}

                                                                  {itemIndex ===
                                                                    item
                                                                      ?.getProjectCertifications
                                                                      .length -
                                                                      1 && (
                                                                    <button
                                                                      className="btnTable width-40 ml-6 mt-1"
                                                                      onClick={() =>
                                                                        addProjectCertifications(
                                                                          index,
                                                                        )
                                                                      } // Fixed: Pass as a callback
                                                                    >
                                                                      <i className="bi bi-plus-lg"></i>{" "}
                                                                      Add
                                                                    </button>
                                                                  )}
                                                                </div>
                                                              </Col>
                                                            </>
                                                          )}
                                                        </Row>
                                                      ),
                                                    )}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Locations
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <GoogleMapComponent
                                                    projectIndex={index}
                                                    getmapdata={onHandleMapData}
                                                    passmapdata={
                                                      item?.getLocations || []
                                                    }
                                                    editstatus={editMode}
                                                  />
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <hr />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}
                </>
              )}
            </div>
          </Col>
        </Row>

        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />
        <ApproveRemarksModal
          show={modalShowApprove}
          onHide={() => hideModalApprove()}
          onvaluechange={handleValueChange}
        />

        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
      </main>
    </>
  );
};

export default CustomerRegistrationDetailsV2;
